export default {
  // common
  'extractor.common.upload': 'Click to upload file',
  'extractor.common.try': 'Try：',
  'extractor.home': 'Home',
  'extractor.button.download': 'Download',
  'extractor.button.fullScreen': 'Fullscreen',
  'extractor.button.exitFullScreen': 'Exit Fullscreen',
  'extractor.button.showLayer': 'Display recognition results',
  'extractor.button.hiddenLayer': 'Hide recognition results',
  'extractor.error': 'Extraction failed',
  'extractor.law':
    "Please ensure that the documents you upload are legal and compliant, and we do not assume legal responsibility for the content of the documents. Data Protection Policy Children's Information Protection Policy Service Agreement | © All Rights Reserved.Shanghai ICP 2021009351-21",
  'extractor.button.reUpload': 'Re-Upload',
  'extractor.failed': 'Unable to extract, no data to display yet',
  'extractor.common.extracting': 'Extracting, please wait',
  'extractor.common.extracting.queue': 'Queuing for extraction, currently ranked at {id}',
  'extractor.common.loading': 'Loading',
  'extractor.common.pdf.demo1': 'Example1.pdf',
  'extractor.common.pdf.demo2': 'Example2.pdf',
  'extractor.common.formula.detect.demo1': 'FormulaDetail1.jpg',
  'extractor.common.formula.extract.demo1': 'FormulaExtract1.jpg',
  'extractor.common.login.desc': 'Functionality available after login',

  // md
  'extractor.markdown.preview': 'Preview',
  'extractor.markdown.code': 'Code',

  // home
  'extractor.home.title': 'Welcome to Miner U',
  'extractor.home.subTitle': 'Upload documents and intelligently extract them into Markdown format',

  'extractor.side.extractTask': 'Extraction Tasks',
  'extractor.side.extractTask.title': 'Please upload a PDF document within 5M (within 10 pages) or a JPG/PNG image',

  // pdf
  'extractor.pdf.title': 'PDF Document Extraction',
  'extractor.pdf.subTitle':
    'Supports text/scanned PDF parsing, identifies various layout elements and converts them into multimodal Markdown format',
  'extractor.common.pdf.upload.tip': 'Please upload a PDF document within 5M and no more than 10 pages',

  'extractor.pdf.ocr': 'OCR Identify Pattern',

  'extractor.pdf.ocr.popover':
    'By default, PDF types (text-based, scanned) will be automatically recognized, and based on the recognition results, you can choose to use text recognition or OCR recognition. If enabled, all types of PDF will be recognized by OCR.',

  // formula
  'extractor.formula.title2':
    'Recognize mathematical formulas in images as LaTex format, support multi-line formulas and handwritten formula recognition',
  'extractor.formula.title': 'Locate the formulas within and between rows in the image and generate bounding boxes',
  'extractor.formula.upload.text': 'Click to upload an image',
  'extractor.formula.popover.extract':
    'In order to obtain the best formula recognition effect, please crop the image, focus on the formula part, and upload a clear, watermark-free image of the mathematical formula, as shown below',
  'extractor.formula.popover.detect':
    'In order to get the best formula recognition effect, please upload clear, non-watermarked images containing mathematical formulas, as shown below',
  'extractor.formula.upload.accept': 'Please upload a JPG/PNG image within 5M',
  'extractor.formula.upload.try': 'Please upload an image containing a mathematical formula Example: ',

  // guide
  'extractor.guide.title': 'Welcome to use more open source products 🎉',

  // queue
  'extractor.queue': 'Extract records',
  'extractor.queue.delete': 'Confirm to delete this file?',
  'extractor.queue.extracting': 'Extracting',

  // feedback
  'extractor.feedback.title1': 'Are you satisfied with the overall extraction performance?',
  'extractor.feedback.title3': 'Look forward to your suggestions to help us better optimize',
  'extractor.feedback.up.title': 'What improvements are you expecting to see?',
  'extractor.feedback.down.title': 'What is the reason for your dissatisfaction? ',
  'extractor.feedback.up': 'Satisfied',
  'extractor.feedback.down': 'Dissatisfied',
  'extractor.feedback.input.placeholder': 'Please enter your suggestions for improvement',
  'extractor.feedback.input.submit': 'Submit',
  'extractor.feedback.success': 'Thank you for the feedback',

  'mineru.docs.tab1': 'MinerU Docs',
  'mineru.docs.tab2': 'API Tokens',
  'mineru.docs.tab3': 'Throttling Strategy',
  'mineru.docs.api.token.title':
    'Token will be used to verify your account identity when calling the MinerU API. Please keep your API safe and do not expose it to the code in your browser or other clients. The API is currently in the trial run test phase. Please contact the operation team if you have any questions.',
  'mineru.docs.api.token.title2': 'Note that all API Tokens are subject to the MinerU API {limit}.',
  'mineru.docs.api.token.limit': 'Throttling Strategy',
  'mineru.docs.api.token.deleteConfirmTitle': 'Confirm to delete this API Token?',
  'mineru.docs.api.token.deleteConfirmContent':
    'After deletion, you will no longer be able to use this API Token to call the MinerU API',
  'mineru.docs.api.token.delete': 'Delete',
  'mineru.docs.api.token.name': 'Name',
  'mineru.docs.api.token.token': 'Token',
  'mineru.docs.api.token.status': 'Status',
  'mineru.docs.api.token.readWrite': 'Read/Write',
  'mineru.docs.api.token.expired': 'Expired',
  'mineru.docs.api.token.createdAt': 'Created At',
  'mineru.docs.api.token.expiredAt': 'Expired At',
  'mineru.docs.api.token.permission': 'Permission',
  'mineru.docs.api.token.create': 'Create API Token',
  'mineru.docs.api.token.actions': 'Actions',
  'mineru.docs.api.token.create.warning':
    'In order to ensure the security of your data, after clicking Confirm, you will no longer be able to see this API Token. Please keep it safe. If it is accidentally lost, you need to generate a new API Token',
  'mineru.docs.api.token.name.placeholder': 'Please enter Chinese, English, numbers, or characters',

  'mineru.api.apply.title': 'MinerU API Application Questionnaire (Beta)',
  'mineru.api.apply.subTitle':
    'Welcome to apply for MinerU API service! Please fill out and submit this application form. If approved, we will guide you on how to use it via email. The current API is still in the testing phase and may be unstable. If you have any questions or suggestions, please contact us promptly. Thank you for your support! 🙌',
  'mineru.api.apply.userType': 'Are you an individual user or a business user?',
  'mineru.api.apply.userType.personal': 'Individual User',
  'mineru.api.apply.userType.enterprise': 'Business User',
  'mineru.api.apply.cooperation': 'Are you willing to participate in our data cooperation?',
  'mineru.api.apply.cooperation.yes': 'Yes',
  'mineru.api.apply.cooperation.no': 'No',
  'mineru.api.apply.companyName': 'Your company name',
  'mineru.api.apply.fileCount': 'How many PDF files do you have for conversion?',
  'mineru.api.apply.fileSize': 'What is the size of a single PDF file? (Unit: GB)',
  'mineru.api.apply.provideMethod': 'How do you want to provide data?',
  'mineru.api.apply.provideMethod.disk': 'Disk Mailing',
  'mineru.api.apply.provideMethod.webLink': 'Web Link',
  'mineru.api.apply.provideMethod.webSocket': 'Web Link',
  'mineru.api.apply.provideMethod.ftp': 'FTP Transfer',
  'mineru.api.apply.provideMethod.api': 'API Transfer',
  'mineru.api.apply.provideMethod.other': 'Other',
  'mineru.api.apply.otherMethod': 'Please specify your other method of providing data',
  'mineru.api.apply.email': 'Your email address',
  'mineru.api.apply.email.invalid': 'Please enter a valid email address',
  'mineru.api.apply.phone': 'Your contact phone number',
  'mineru.api.apply.phone.invalid': 'Please enter a valid phone number',
  'mineru.api.apply.wechat': 'Your WeChat',
  'mineru.api.apply.openQuestion': 'Do you have any suggestions or questions about our PDF collaboration project?',
  'mineru.docs.api.token.name.required': 'API Token name cannot be empty',
  'mineru.docs.api.token.createSuccess': 'API Token created successfully',
  'mineru.docs.api.token.saveWarning':
    'In order to ensure the security of your data, after clicking Confirm, you will no longer be able to see this API Token. Please keep it safe. If it is accidentally lost, you need to generate a new API Token',
  'mineru.docs.api.token.saveTitle': 'Save API Token',
  'mineru.docs.api.token.create.limit': 'Currently, you can create up to 5 API Tokens, please delete and create again',

  'extractor.dataProcess.mineru.multiFormatExtract': 'Multi-format extraction: PDF, Word, PPT',
  'extractor.dataProcess.mineru.localDeploy': 'Local Deployment',
  'extractor.dataProcess.mineru.onlineExplore': 'Online Experience',
  'extractor.dataProcess.mineru.apiApply': 'API Application',
  'extractor.dataProcess.mineru.apiApply.process.tooltip': 'API application is under review, please wait patiently',
  'extractor.dataProcess.mineru.apiApply.manage': 'API Management',

  'mineru.docs.api.token.deleteSuccess': 'Delete successfully',
  'mineru.docs.api.token.name.duplicate': 'API Token name cannot be duplicated',
  'mineru.docs.api.token.warning':
    'In order to ensure the security of your data, all API Tokens are valid for 14 days. Please update the API Tokens before they expire.',
  'mineru.docs.api.token.noPermission':
    'You do not have access to the API management interface. Please apply for API access first and retry after approval.',
  'extractor.taskManagement.selected': 'Selected {n} items'
};
